import { useEffect } from "react";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faDownload } from '@fortawesome/free-solid-svg-icons'
export default function PWADownloadLink() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Listen for the beforeinstallprompt event
        const handler = (e) => {
            e.preventDefault(); // Prevent the mini-infobar
            setDeferredPrompt(e); // Save the event for later
            setIsVisible(true); // Show the install button
        };

        window.addEventListener("beforeinstallprompt", handler);

        // Cleanup listener on unmount
        return () => window.removeEventListener("beforeinstallprompt", handler);
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;

        deferredPrompt.prompt(); // Show the install prompt

        const { outcome } = await deferredPrompt.userChoice;
        console.log(`User response to install prompt: ${outcome}`);

        // Reset prompt so it can’t be used again
        setDeferredPrompt(null);
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (<button onClick={handleInstallClick} style={{ border: 'none', background: 'transparent', color: 'white', borderRadius: '100%', }}>
        <FontAwesomeIcon icon={faDownload} />
        {/*<b style={{ color: '#354572', fontWeight: 'normal' }}>D</b>ownload*/}
    </button>)
}